import { render, staticRenderFns } from "./TourSetup.vue?vue&type=template&id=22df5bf8&scoped=true"
import script from "./TourSetup.vue?vue&type=script&lang=ts"
export * from "./TourSetup.vue?vue&type=script&lang=ts"
import style0 from "./TourSetup.vue?vue&type=style&index=0&id=22df5bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df5bf8",
  null
  
)

export default component.exports